import { RenderComponent } from '@/node-editor';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteContainer } from './container';
import { fetchPageBySlugService } from '@/services/pageService';
import { IPage, IPageTemplate } from '@/types/page';

interface IProps {
  authState: {
    stateLoaded: boolean;
    userLoggedIn: boolean;
    [key: string]: unknown;
  };
  rootPath: string;
}

export const SitePage = ({ authState, rootPath }: IProps) => {
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState<IPage | IPageTemplate | null>(null);
  const path = rootPath || location.pathname ;

  useEffect(() => {
    let mounted = true;

    fetchPageBySlugService(window.CONFERENCE_ID, path)
      .then((response) => mounted && setPage(response.data))
      .finally(() => mounted && setLoaded(true));

    return () => {
      mounted = false;
    };
  }, [path]);

  return (
    <SiteContainer {...authState} path={path}>
      {loaded && <RenderComponent entity={page} />}
    </SiteContainer>
  );
};
